import { track } from "@/lib/analytics/client";

/** Cap events per blocked submit, so a form with 30 errors sends 30 rows once. */
const MAX_FIELDS_PER_SUBMIT = 5;

/**
 * Records that client-side validation stopped a submit.
 *
 * This is the friction backend logs CANNOT see: the request never leaves the
 * browser, so `api.failed` and server logs are both blind to it. A user who
 * cannot get past a form is indistinguishable, server-side, from a user who
 * never tried.
 *
 * `field` must be a static field name from the form schema. Never pass a
 * value, a message, or anything derived from user input — the catalog types
 * this as a plain string and cannot enforce that for you.
 */
export function trackValidationBlocked(form: string, field: string): void {
  track("friction.validation", { form, field });
}

/**
 * react-hook-form adapter: pass as the `onInvalid` argument of handleSubmit.
 *
 *   onSubmit={form.handleSubmit(onValid, formErrorsTracker("registration"))}
 *
 * Error KEYS are recorded, never messages — a message can be interpolated
 * with what the user typed, whereas keys come from the schema.
 */
export function formErrorsTracker(
  form: string,
): (errors: Record<string, unknown>) => void {
  return (errors) => {
    for (const field of Object.keys(errors).slice(0, MAX_FIELDS_PER_SUBMIT)) {
      trackValidationBlocked(form, field);
    }
  };
}
